module.exports = __webpack_public_path__ + "static/img/silverchair-logo.e021caa6.svg";